import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Brain, Zap, TrendingUp, Cpu } from 'lucide-react'

const AIAutomation = () => {
  const features = [
    {
      icon: <Brain className="w-6 h-6" data-component-path="client/src/pages/services/AIAutomation.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/AIAutomation.jsx:7:12" />,
      title: 'Machine Learning',
      description: 'Intelligent systems that learn and improve'
    },
    {
      icon: <Zap className="w-6 h-6" data-component-path="client/src/pages/services/AIAutomation.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/AIAutomation.jsx:13:12" />,
      title: 'Process Automation',
      description: 'Eliminate repetitive tasks automatically'
    },
    {
      icon: <TrendingUp className="w-6 h-6" data-component-path="client/src/pages/services/AIAutomation.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/AIAutomation.jsx:19:12" />,
      title: 'Predictive Analytics',
      description: 'Forecast trends with AI-powered insights'
    },
    {
      icon: <Cpu className="w-6 h-6" data-component-path="client/src/pages/services/AIAutomation.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/AIAutomation.jsx:25:12" />,
      title: 'Smart Integration',
      description: 'AI seamlessly integrated into workflows'
    },
  ]

  return (
    <ServiceTemplate
      title="AI & Automation"
      subtitle="Transform operations with intelligent automation and machine learning"
      description="Harness the power of artificial intelligence to automate complex processes, gain predictive insights, and make data-driven decisions. Our AI solutions integrate seamlessly with your existing systems to deliver measurable business impact."
      features={features}
      heroImage="https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default AIAutomation